import React from 'react';
import { ModalWrapper } from './styles';
import { ModalProps } from './types';

const Modal: React.FC<ModalProps> = ({
  title,
  centered,
  visible,
  onCancel,
  width,
  children,
  variant = 'default',
}) => {
  const isSplash = variant === 'splash';

  return (
    <ModalWrapper
      title={title}
      centered={centered}
      visible={visible}
      onCancel={onCancel}
      width={width}
      footer={null}
      className={isSplash ? 'modal-splash' : undefined}
    >
      {children}
    </ModalWrapper>
  );
};

export default Modal;